import React from 'react';

interface RightSideMenuProps {
  showRightSidePanel: boolean;
  showAddTrackPanel: boolean;
  showReorderPanel: boolean;
  showAdjustmentsPanel: boolean;
  showAddStatisticsPanel: boolean;
  showCorrelationPanel: boolean;
  showSummaryReport: boolean;
  onShowHideAdjustmentsPanel: () => void;
  onShowAddTrackPanel: () => void;
  onShowReorderPanel: () => void;
  onShowAdjustments: () => void;
  onShowAddStatistics: () => void;
  onShowCorrelationPanel: () => void;
}

const RightSideMenu: React.FC<RightSideMenuProps> = ({
  showRightSidePanel,
  showAddTrackPanel,
  showReorderPanel,
  showAdjustmentsPanel,
  showAddStatisticsPanel,
  showCorrelationPanel,
  showSummaryReport,
  onShowHideAdjustmentsPanel,
  onShowAddTrackPanel,
  onShowReorderPanel,
  onShowAdjustments,
  onShowAddStatistics,
  onShowCorrelationPanel,
}) => {
  return (
    <div className="right-side-menu-panel" style={{ marginRight: showRightSidePanel ? 427 : 0 }}>
      <button 
        className="button is-tab button-icon" 
        onClick={onShowHideAdjustmentsPanel} 
        title="Close"
      >
        {showRightSidePanel ? (
          <img src={"/images/icons/Atlas Open 2 Icon.svg"} alt="Close panel" />
        ) : (
          <img src={"/images/icons/Atlas Open 1 Icon.svg"} alt="Open panel" />
        )}
      </button>
      <button 
        className={`button is-tab button-icon mt-1 ${showAddTrackPanel ? "highlighted" : ""}`} 
        onClick={onShowAddTrackPanel} 
        title="Add Track"
      >
        <img src={"/images/icons/Atlas Add Track Icon.svg"} alt="Add Track" />
      </button>
      <button 
        className={`button is-tab button-icon mt-1 ${showReorderPanel ? "highlighted" : ""}`} 
        onClick={onShowReorderPanel} 
        title="Reorder"
      >
        <img src={"/images/icons/Atlas Reorder Icon.svg"} alt="Reorder" />
      </button>
      <button 
        className={`button is-tab button-icon mt-1 ${showAdjustmentsPanel ? "highlighted" : ""}`} 
        onClick={onShowAdjustments} 
        title="Adjustments"
      >
        <img src={"/images/icons/Atlas Adjustment Icon.svg"} alt="Adjustments" />
      </button>
      {showSummaryReport && (
        <button 
          className={`button is-tab button-icon mt-1 ${showAddStatisticsPanel ? "highlighted" : ""}`} 
          onClick={onShowAddStatistics} 
          title="Statistics for report"
        >
          <img src={"/images/icons/calculator-svgrepo-com 2.svg"} alt="Statistics for report" />
        </button>
      )}
      <button 
        className={`button is-tab button-icon mt-1 ${showCorrelationPanel ? "highlighted" : ""}`} 
        onClick={onShowCorrelationPanel} 
        title="Add Borehole"
      >
        <img src={"/images/icons/Correlation Icon.svg"} alt="Add Borehole" />
      </button>
    </div>
  );
};

export default RightSideMenu;
